import * as THREE from "three";

/*export function ForUsingUVsAsQuadVectors_FixWindingOrder(uv1: THREE.BufferAttribute) {
	// check if uv1 (re-interpreted as an on-screen quad) would even be rendered! (given the counter-clockwise winding that threejs uses + frontface culling); if not, then flip the uv1 coords
	const existingWinding = uv1.array[0] * uv1.array[3] - uv1.array[1] * uv1.array[2];
	if (existingWinding < 0) {
		for ( let i = 0; i < uv1.array.length; i += uv1.itemSize ) {
			uv1.array[ i ] = 1 - uv1.array[ i ];
		}
	}
}*/

/*export function ForUsingUVsAsQuadVectors_FixWindingOrder(uv1: THREE.BufferAttribute, obj: THREE.Object3D) {
	// check if uv1 (re-interpreted as an on-screen quad) would even be rendered! (given the counter-clockwise winding that threejs uses + frontface culling); if not, then flip the uv1 coords
	const existingWinding = obj.geometry.attributes.position.array.slice(0, 9);
	const newWinding = uv1.array.slice(0, 6);
	const flipped = (existingWinding[0] - existingWinding[3]) * (newWinding[1] - newWinding[4]) - (existingWinding[1] - existingWinding[4]) * (newWinding[0] - newWinding[3]) < 0;
	if (flipped) {
		for ( let i = 0; i < uv1.array.length; i += uv1.itemSize ) {
			uv1.array[ i ] = 1 - uv1.array[ i ];
		}
	}
}*/

export function ForUsingUVsAsQuadVectors_FixWindingOrder(uv1: THREE.BufferAttribute, obj: THREE.Mesh) {
	const positions = obj.geometry.getAttribute("position");
	const indices = obj.geometry.getIndex()!;

	// Helper function to calculate winding order for a triangle
	function getTriangleWinding(p1, p2, p3) {
		// Cross product to determine winding
		const v1x = p2.x - p1.x;
		const v1y = p2.y - p1.y;
		const v2x = p3.x - p1.x;
		const v2y = p3.y - p1.y;
		return v1x * v2y - v1y * v2x;
	}

	// Count triangles with positive and negative winding
	let posWindingCount = 0;
	let negWindingCount = 0;

	// Check a reasonable number of triangles (not just the first one)
	const maxTrianglesToCheck = Math.min(50, Math.floor(indices.count / 3));

	for (let i = 0; i < maxTrianglesToCheck; i++) {
		const i0 = indices.getX(i * 3);
		const i1 = indices.getX(i * 3 + 1);
		const i2 = indices.getX(i * 3 + 2);

		// Get positions for this triangle
		/*const p1 = {x: positions.getX(i0), y: positions.getY(i0)};
		const p2 = {x: positions.getX(i1), y: positions.getY(i1)};
		const p3 = {x: positions.getX(i2), y: positions.getY(i2)};*/
		// Calculate winding in 3D space (projected to XY plane for simplicity)
		const geomWinding = 1; //getTriangleWinding(p1, p2, p3); // assume geometry-winding of 1 (normal), since geometry may itself be flipped! (well, flipped in the sense of UVs-interpreted-as-screen-space-quad-vectors being wrong, not in the sense of normals)

		// Get UVs for this triangle
		const uv1_temp = {x: uv1.getX(i0), y: uv1.getY(i0)};
		const uv2_temp = {x: uv1.getX(i1), y: uv1.getY(i1)};
		const uv3_temp = {x: uv1.getX(i2), y: uv1.getY(i2)};
		// Calculate winding in UV space
		const uvWinding = getTriangleWinding(uv1_temp, uv2_temp, uv3_temp);

		// Compare winding directions
		if (geomWinding * uvWinding > 0) {
			posWindingCount++;
		} else {
			negWindingCount++;
		}
	}

	// Flip UVs if the majority of triangles have inconsistent winding
	const flipped = negWindingCount > posWindingCount;
	if (flipped) {
		for (let i = 0; i < uv1.array.length; i += uv1.itemSize) {
			uv1.array[i] = 1 - uv1.array[i];
		}
	}
}

/*export function ForUsingUVsAsQuadVectors_FixWindingOrder(uv1: THREE.BufferAttribute, obj: THREE.Mesh) {
	const positions = obj.geometry.getAttribute("position");
	const indices = obj.geometry.getIndex()!;
	
	// Helper function to calculate winding order for a triangle
	function getTriangleWinding(p1, p2, p3) {
		// Cross product to determine winding
		const v1x = p2.x - p1.x; 
		const v1y = p2.y - p1.y;
		const v2x = p3.x - p1.x;
		const v2y = p3.y - p1.y;
		return v1x * v2y - v1y * v2x;
	}
	
	for (let i = 0; i < Math.floor(indices.count / 3); i++) {
		const i0 = indices.getX(i * 3);
		const i1 = indices.getX(i * 3 + 1);
		const i2 = indices.getX(i * 3 + 2);
		
		// Get UVs for this triangle
		const uv1_temp = {x: uv1.getX(i0), y: uv1.getY(i0)};
		const uv2_temp = {x: uv1.getX(i1), y: uv1.getY(i1)};
		const uv3_temp = {x: uv1.getX(i2), y: uv1.getY(i2)};
		// Calculate winding in UV space
		const uvWinding = getTriangleWinding(uv1_temp, uv2_temp, uv3_temp);
		
		// if winding-order is wrong for this triangle (when the UVs are interpreted as screen-space quad-vectors), flip the UVs (for just this triangle, because such interpreted-winding-order can differ per triangle/face)
		if (uvWinding < 0) {
			/*uv1.array[i0] = 1 - uv1.array[i0];
			uv1.array[i1] = 1 - uv1.array[i1];
			uv1.array[i2] = 1 - uv1.array[i2];*#/
			uv1.setX(i0, 1 - uv1.getX(i0));
			uv1.setX(i1, 1 - uv1.getX(i1));
			uv1.setX(i2, 1 - uv1.getX(i2));
		}
	}
}*/